/** Horizontal mic level from dBFS (-60 dB = empty, -10 dB = full). */
export function LevelBar({ db, label = 'Microphone level' }: { db: number; label?: string }) {
  const pct = Math.max(0, Math.min(100, ((db + 60) / 50) * 100));
  return (
    <div className="level-bar" role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(pct)}>
      <div className="level-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
